import { UserProfileType } from 'entities/user/model/types';
import { UserDataFormType } from 'entities/users/types';

export const useUpdateUserDataDefaultValues = (user: UserProfileType): UserDataFormType => ({
  country_id: user?.city?.country_id,
  phone: user.phone,
  user_role_ids: user.user_roles.map((role) => role.id) ?? [],
  source_id: user.source_id,
  channel: '',
  is_b2b: user.is_b2b,
  is_b2cr: user.is_b2cr,
  is_b2c: user.is_b2c,
});
